﻿import { FIREWEATHER_API_URL } from './env';

// ! Okta

import {
    authClient
} from './okta-auth';

import * as DateManager from './dates'

export function getLayerState(layer, callback, onerror) {
    __non_webpack_require__([
        'esri/request'
    ], function(esriRequest) {
        var layersRequest = esriRequest({
            url: FIREWEATHER_API_URL + "/element",
            content: {
                f: 'json',
                name: layer.id,
            },
            handleAs: 'json',
        });
        layersRequest.then(
            function(response) {
                var currentDate = new Date();

                var status = {};

                var state_data
                for (var i = 0; i < response.LayerInfos.length; i++) {
                    state_data = response.LayerInfos[i];
                    // temporarily fill 'Region' tag
                    state_data.Region = state_data.Name.split('_')[1]

                    status[state_data.Region] = state_data.Status
                }

                callback(status)
            },
            function(err) {
                err.layer = layer
                console.log("Error: ", err.message);
                if (onerror) {
                    onerror(err)
                }
            });
    });
}

export function getLayerMetadata(layer, callback, onerror) {

        let uri = `${FIREWEATHER_API_URL}/products/active`;

        // Get the access token
        const { idToken, accessToken, refreshToken } = authClient.tokenManager.getTokensSync();

        $.ajax({
            url: uri,
            method: 'GET',
            headers: {
                'Authorization': `Bearer ${accessToken.accessToken}` 
            },
            success: function(response) {
                const currentDate = new Date();
                const old_data = [];
                const warnings = [];

                let diff;
                for (var i = 0; i < response.length; i++) { 
                    if (response[i].image_type === layer.geoserverId){
                        const issue_time = response[i].issue_time;
                        diff = DateManager.dateDiff(currentDate, DateManager.dateFromStr(issue_time, "yyyy-MM-ddThh:mm:ss.xx"));
                        if (diff > 12 && diff <= 336) {
                            console.log(`${layer.geoserverId}-${i}`);
                            old_data.push('National');
                        }
                    }
                }

                // display warnings
                if (old_data.length > 0) {
                    warnings.push("The " + layer.name + " forecast is more than 12 hours old.<br> " +
                        "The information displayed is no longer the current official forecast");
                }

                // NB pending and processing will no longer apply
                response.warnings = warnings
                response.layer = layer
                callback(response)
            },
            error: function(xhr, status, err) {
                err.layer = layer
                console.log("BIG SAD!");
                console.log("Error: ", err.message);
                if (onerror) {
                    onerror(err)
                }
            }
        })

        // $.getJSON(uri).then(
        //     function(response) {

        //         const currentDate = new Date();
        //         const old_data = [];
        //         const warnings = [];

        //         let diff;
        //         for (var i = 0; i < response.length; i++) { 
        //             if (response[i].image_type === layer.geoserverId){
        //                 const issue_time = response[i].issue_time;
        //                 diff = DateManager.dateDiff(currentDate, DateManager.dateFromStr(issue_time, "yyyy-MM-ddThh:mm:ss.xx"));
        //                 if (diff > 12 && diff <= 336) {
        //                     console.log(`${layer.geoserverId}-${i}`);
        //                     old_data.push('National');
        //                 }
        //             }
        //         }

        //         // display warnings
        //         if (old_data.length > 0) {
        //             warnings.push("The " + layer.name + " forecast is more than 12 hours old.<br> " +
        //                 "The information displayed is no longer the current official forecast");
        //         }

        //         // NB pending and processing will no longer apply
        //         response.warnings = warnings
        //         response.layer = layer
        //         callback(response)

        //     },
        //     function(err) {
        //         err.layer = layer
        //         console.log("Error: ", err.message);
        //         if (onerror) {
        //             onerror(err)
        //         }
        //     });

}

export function updateLayerMetadata(layer) {
    getLayerMetadata(layer, function(results) {
        if (results.warnings.length > 0) {
            $('#dateAlertText').html(results.warnings.join("<br><br>"));
            $('#dateAlert').show();
        } else {
            $('#dateAlert').hide();
        }
    })
}